import client from "./client";

export default {

    async getChargeTypes(filters) {
        return client.parseResponse(await client.get('/charge-types', filters));
    },
    async getChargeType(id) {
        return client.parseResponse(await client.get('/charge-types/' + id));
    },
    async createChargeType(data) {
        return client.parseResponse(await client.post('/charge-types', data))
    },
    async editChargeType(data) {
        return client.parseResponse(await client.put('/charge-types/' + data.id, data))
    },
    async deleteChargeType(data) {
        return client.parseResponse(await client.delete('/charge-types/' + data.id, data))
    }
}
